import * as actionTypes from '../../constants/ActionTypes/Authentication/SignIn_SignUp_Auth';
import { SIGNUPTYPE } from '../../constants/AppConstants';

export const handleLogin = (signUpType = SIGNUPTYPE.MOBILE, deviceId = null) => ({
    type: actionTypes.APP_SIGN_IN_SERVICE_INIT,
    signUpType,
    deviceId
})